module.exports = __webpack_public_path__ + "img/desert-apple-1600x800.514b3fbc.jpg";